import React from "react";

import KritikSaranStatusBadge from "../../components/kritik/KritikSaranStatusBadge";

import KritikSaranTimeline from "../../components/kritik/KritikSaranTimeline";

const KritikSaranDetail = ({
  kritikSaran = {},
}) => {
  return (
    <>
      <div className="row">
        {/* DETAIL */}
        <div className="col-md-5 mb-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-primary text-white">
              <div className="fw-semibold">
                Detail Kritik & Saran
              </div>
            </div>

            <div className="card-body">
              {/* KODE */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Kode
                </small>

                <div className="fw-semibold">
                  {kritikSaran.kode || "-"}
                </div>
              </div>

              {/* KATEGORI */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Kategori
                </small>

                <div
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  {kritikSaran.kategori ||
                    "-"}
                </div>
              </div>

              {/* STATUS */}
              <div className="mb-3">
                <small className="text-muted d-block mb-1">
                  Status
                </small>

                <KritikSaranStatusBadge
                  status={
                    kritikSaran.status
                  }
                />
              </div>

              {/* PENGIRIM */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Pengirim
                </small>

                <div>
                  {kritikSaran.is_anonim
                    ? "Anonim"
                    : kritikSaran.pengirim_type}
                </div>
              </div>

              {/* TUJUAN */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Tujuan
                </small>

                <div>
                  {/* PEGAWAI */}
                  {kritikSaran.tujuan_type ===
                    "pegawai" && (
                    <>
                      Pegawai #
                      {
                        kritikSaran.tujuan_id
                      }
                    </>
                  )}

                  {/* DOSEN */}
                  {kritikSaran.tujuan_type ===
                    "dosen" && (
                    <>
                      Dosen #
                      {
                        kritikSaran.tujuan_id
                      }
                    </>
                  )}

                  {/* GROUP */}
                  {kritikSaran.tujuan_type ===
                    "group" && (
                    <>
                      Group :{" "}
                      {
                        kritikSaran.tujuan_manual
                      }
                    </>
                  )}

                  {/* UMUM */}
                  {kritikSaran.tujuan_type ===
                    "umum" && (
                    <>
                      Umum :{" "}
                      {
                        kritikSaran.tujuan_manual
                      }
                    </>
                  )}
                </div>
              </div>

              {/* JUDUL */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Judul
                </small>

                <div className="fw-semibold">
                  {kritikSaran.judul}
                </div>
              </div>

              {/* ISI */}
              <div className="mb-3">
                <small className="text-muted d-block">
                  Isi
                </small>

                <div
                  className="border rounded p-3 bg-light"
                  style={{
                    whiteSpace:
                      "pre-wrap",
                  }}
                >
                  {kritikSaran.isi}
                </div>
              </div>

              {/* LAMPIRAN */}
              {kritikSaran.lampiran && (
                <div className="mb-3">
                  <small className="text-muted d-block mb-2">
                    Lampiran
                  </small>

                  <a
                    href={`${process.env.REACT_APP_STORAGE_URL}/kritik_saran_up/${kritikSaran.lampiran}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <i className="fa fa-fw fa-paperclip me-1" />
                    Lihat Lampiran
                  </a>
                </div>
              )}

              {/* TIMESTAMP */}
              <div className="mb-2">
                <small className="text-muted d-block">
                  Dibuat
                </small>

                <div>
                  {
                    kritikSaran.created_at
                  }
                </div>
              </div>

              <div>
                <small className="text-muted d-block">
                  Diupdate
                </small>

                <div>
                  {
                    kritikSaran.updated_at
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* TIMELINE */}
        <div className="col-md-7 mb-3">
          <KritikSaranTimeline
            kritikSaran={
              kritikSaran
            }
          />
        </div>
      </div>
    </>
  );
};

export default KritikSaranDetail;